<div class="columns is-centered m-0" data-qa-id="Navigation Restricted Error">
  <div class="column is-10 my-4">
    <app-error-notification classes="p-3 has-text-black">
      <p class="is-inline">
        Your consultation request has been confirmed and payment has been successfully processed. Please continue
        forward to add additional requests, or email us at {{ contactEmail }} if you need assistance.
      </p>
    </app-error-notification>
  </div>
</div>
